import { styled } from '@linaria/react';
import { Stack } from '@mantine/core';
import { useContext } from 'react';
import { baseWhite } from '../../../styles/design-tokens';
import { Text } from '../../../ui-library/typography/typography';
import { SidebarContext } from '../../side-bar/side-bar.context';
import { Goals } from '../../work-periods/assessment-view/sections/goals-section';

function SectionGoals({ workPeriodId }: { workPeriodId: string }) {
  const { viewAreaWidth } = useContext(SidebarContext);

  return (
    <Container viewAreaWidth={viewAreaWidth}>
      <Stack w="100%">
        <Text size="large" weight="bold">
          Goals
        </Text>
        <Goals workPeriodId={workPeriodId} />
      </Stack>
    </Container>
  );
}

const Container = styled.div<{ viewAreaWidth: number }>`
  background-color: ${baseWhite};
  padding: 16px 24px;
  display: flex;
  flex-direction: ${(props) => (props.viewAreaWidth >= 1400 ? 'row' : 'column')};
  justify-content: space-between;
  align-items: ${(props) => (props.viewAreaWidth >= 1400 ? 'flex-start' : 'center')};
`;

export { SectionGoals };
